import { NavLink } from "react-router-dom";
import { tabs } from "../tabs";
import "../css/layout.css"

export default function Tabs() {
  return (
    <nav>
      <ul className="tab">
        {tabs.map((entry) => {
          return (
            <li key={entry.id}>
              <NavLink 
                id={entry.id.toString()}  
                to={entry.path} 
                style={({isActive}) => ({color: isActive ? 'rgb(0, 203, 255)' : 'rgb(0, 0, 0)', })}
              >
                {entry.text}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  )
}
